import { useCallback } from 'react'

import { useCountry } from './useCountry'

export const usePWAManifest = () => {
  const country = useCountry()

  const createPWAManifest = useCallback(() => {
    const manifest = document.createElement('link')

    manifest.rel = 'manifest'
    manifest.href = `/ai/manifests/${country}.json`

    document.head.appendChild(manifest)
  }, [country])

  return {
    createPWAManifest,
  }
}
